import {
  CopayTriageReasons,
  OrderStatus,
  TriageReasons,
  TriageReasonsToExcludeFromManualAction,
  getTriageReasonsByStatus,
  triageReasonsByStatus,
} from '@truepill/tpos-types'

function generateCopayTriageReasonMap() {
  const reasonMap: { [key: string]: CopayTriageReasons } = {}
  Object.entries(CopayTriageReasons).forEach(([key, value]) => {
    reasonMap[key] = value
  })
  return reasonMap
}

function generateTriageReasonMap() {
  const reasonMap: { [key: string]: TriageReasons } = {}
  Object.values(TriageReasons).forEach(reasonCollection => {
    Object.entries(reasonCollection).forEach(([key, value]) => {
      reasonMap[key] = value
    })
  })
  return reasonMap
}

function filterManualTriageReasons(reasons: string[]): string[] {
  return [...reasons].filter(r => !Object.values(TriageReasonsToExcludeFromManualAction).includes(r)).sort()
}

export const TriageReasonMap: { [id: string]: TriageReasons } = generateTriageReasonMap()
export const CopayTriageReasonMap: { [id: string]: CopayTriageReasons } = generateCopayTriageReasonMap()

const BULK_TRIAGE_STATUSES = [OrderStatus.PV1, OrderStatus.Fill, OrderStatus.PV2, OrderStatus.Packing]

const BULK_TRIAGE_QUEUE_REASONS = [
  ...new Set(BULK_TRIAGE_STATUSES.flatMap(status => triageReasonsByStatus.get(status) ?? [])),
]

export const getBulkTriageReasons = (orderStatus?: OrderStatus, hasOtc = false): string[] => {
  if (!orderStatus || !BULK_TRIAGE_STATUSES.includes(orderStatus)) {
    return filterManualTriageReasons(BULK_TRIAGE_QUEUE_REASONS)
  }
  const reasons = getTriageReasonsByStatus(orderStatus, hasOtc) ?? BULK_TRIAGE_QUEUE_REASONS

  return filterManualTriageReasons(reasons)
}
